import { useQuery } from "@tanstack/react-query";
import { format, subDays } from "date-fns";
import { useState } from "react";
import {
  deliveryApi,
  type DeliveryPerformanceParams,
} from "@/lib/admin-api/delivery";
import type { DateRange } from "@/components/admin/shared";

// ---------------------------------------------------------------------------
// Query key
// ---------------------------------------------------------------------------

const PERF_KEY = "admin-delivery-performance";

function perfQueryKey(params: DeliveryPerformanceParams) {
  return [PERF_KEY, params] as const;
}

// ---------------------------------------------------------------------------
// Hook
// ---------------------------------------------------------------------------

const DEFAULT_DATE_RANGE: DateRange = {
  from: subDays(new Date(), 30),
  to: new Date(),
};

export function useDeliveryPerformance() {
  const [dateRange, setDateRange] = useState<DateRange>(DEFAULT_DATE_RANGE);

  const params: DeliveryPerformanceParams = {
    from: format(dateRange.from, "yyyy-MM-dd"),
    to: format(dateRange.to, "yyyy-MM-dd"),
  };

  const query = useQuery({
    queryKey: perfQueryKey(params),
    queryFn: () => deliveryApi.getPerformance(params),
    staleTime: 60_000,
  });

  return {
    ...query,
    dateRange,
    setDateRange,
    params,
  } as const;
}
